import React from "react";
import { axiosInstance } from "../api/Configuration";
import {v4 as uuidv4} from "uuid";

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {

  const updateAccountInfo = (account) => {
    axiosInstance.defaults.headers.common["username"] = process.env.REACT_APP_USER_EMAIL;
    axiosInstance.defaults.headers.common["userId"] = uuidv4();
    axiosInstance.defaults.headers.common["userEmail"] = account.userName;
  };

  return (
    <AuthContext.Provider
      value={{
        updateAccountInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
